import { observer } from 'mobx-react';
import React from 'react';
import { getCampaignKey, ScaOfferProps } from '../stores/CampaignStore';
import { useStores } from '../stores/RootStore';

interface Props {
  segmentOfferCode?: string;
  scaOffer?: ScaOfferProps;
  recApiOfferCodes?: string | string[];
  children: React.ReactElement;
  not?: boolean;
}

const HasCampaign = observer((props: Props): React.ReactElement => {
  const { ssoStore, campaignStore } = useStores();
  const { segmentOfferCode, children, not, recApiOfferCodes, scaOffer } = props;

  if (segmentOfferCode && recApiOfferCodes) {
    return null;
  }

  React.useEffect(() => {
    campaignStore.loadCampaign({ segmentOfferCode, scaOffer, recApiOfferCodes }, ssoStore.customerId);
  }, [segmentOfferCode, scaOffer, recApiOfferCodes, ssoStore.customerId]);

  const shouldHide = !campaignStore.campaignMap.get(getCampaignKey(props))?.hasCampaign;
  if (shouldHide) {
    return not ? children : null;
  }

  return not ? null : children;
});

export default HasCampaign;
